import { render } from "./UserSelector.vue?vue&type=template&id=1ed017a7&scoped=true"
import script from "./UserSelector.vue?vue&type=script&lang=js"
export * from "./UserSelector.vue?vue&type=script&lang=js"

import "./UserSelector.vue?vue&type=style&index=0&id=1ed017a7&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed017a7"]])

export default __exports__